import { TAILORING_AUDIT_EVENT } from "../server/tailoring-audit-constants.mjs"

export function isTailoringEvent(payload) {
    const event = payload?.event?.split("!").at(0)
    return event === TAILORING_AUDIT_EVENT
}
